import 'regenerator-runtime/runtime';
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {Provider} from "react-redux";
import configureStore from "./redux/config/configureStore";
import history from './utils/history';
import {ConnectedRouter} from 'connected-react-router/immutable';
import {translationMessages} from './utils/i18n';
import LanguageProvider from "./components/LanguageProvider";


const store = configureStore({}, history);
const MOUNTED_DOM = document.getElementById('root');

const render = messages => {
    ReactDOM.render(
        <Provider store={store}>
            <LanguageProvider messages={messages}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </LanguageProvider>
        </Provider>,
        MOUNTED_DOM,
    )
};


if (module.hot) {
    // Hot reloadable React components and translation json files
    // modules.hot.accept does not accept dynamic dependencies,
    // have to be constants at compile-time
    module.hot.accept(['./utils/i18n', './App'], () => {
        ReactDOM.unmountComponentAtNode(MOUNTED_DOM);
        render(translationMessages);
    });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
    new Promise(resolve => {
        resolve(import('intl'));
    })
        .then(() =>
            Promise.all([
                import('intl/locale-data/jsonp/en.js'),
                import('intl/locale-data/jsonp/id.js'),
            ]),
        ) // eslint-disable-line prettier/prettier
        .then(() => render(translationMessages))
        .catch(err => {
            throw err;
        });
} else {
    render(translationMessages);
}



// WEBPACK FOOTER //
// ./src/index.js